import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { http } from "../../utils/httpCommon";
import { useApiUrls } from "../useApiUrl";
import { apiUrls } from "../../utils/apiUrls";
import { useIsFeatureFlagEnabled } from "../../featureFlags/useIsFeatureFlagEnabled";

const unassignShipmentIdsQueryKey = (
  serviceCenterId: number,
  planDate: number
) => ["unassignedShipments", serviceCenterId, planDate];

const unassignedShipmentsResponseSchema = z.array(z.number());

export const useUnassignedShipmentIds = (
  serviceCenterId: number,
  planDate: number
) => {
  const hookUrls = useApiUrls();
  const isEndpointHookEnabled = useIsFeatureFlagEnabled(
    "inbound-3763-endpoint-hook-client"
  );
  const { getUnassignedShipments } = isEndpointHookEnabled ? hookUrls : apiUrls;
  return useQuery({
    queryKey: unassignShipmentIdsQueryKey(serviceCenterId, planDate),
    queryFn: async () => {
      const url = getUnassignedShipments(serviceCenterId, planDate);
      const { data } = await http.get(url);
      return unassignedShipmentsResponseSchema.parse(data);
    },
  });
};
